import React from "react"
import { Thead, Tbody, Tr, TableContainer } from "@chakra-ui/react"

import { scrollBarCss } from "theme/scrollBarCss"
import {
  TableHead as Th,
  SizesTable as Table,
  Cell as Td,
} from "./SizeGuide.styles"

export const CrewNeckGuide: React.FC = () => {
  return (
    <TableContainer mb={3} pb={1} css={scrollBarCss}>
      <Table variant="simple">
        <Thead>
          <Tr>
            <Th wordBreak="break-word">
              True to size - slightly oversized fit
            </Th>

            <Th />
            <Th />
            <Th />
            <Th />
          </Tr>
          <Tr>
            <Th>BEAUTY PIE SIZE</Th>
            <Th>UNISEX SIZE</Th>
            <Th wordBreak="break-word">UK WOMENS SIZING</Th>
            <Th>US WOMENS SIZING</Th>
            <Th>CHEST (inches)</Th>
          </Tr>
        </Thead>
        <Tbody>
          <Tr>
            <Th>0</Th>
            <Td>XS</Td>
            <Td>6-8</Td>
            <Td>2-4</Td>
            <Td>30/32</Td>
          </Tr>
          <Tr>
            <Th>1</Th>
            <Td>S</Td>
            <Td>10-12</Td>
            <Td>6-8</Td>
            <Td>34/36</Td>
          </Tr>
          <Tr>
            <Th>2</Th>
            <Td>M</Td>
            <Td>12-14</Td>
            <Td>8-10</Td>
            <Td>38/40</Td>
          </Tr>
          <Tr>
            <Th>3</Th>
            <Td>L</Td>
            <Td>14-16</Td>
            <Td>10-12</Td>
            <Td>42/44</Td>
          </Tr>
          <Tr>
            <Th>4</Th>
            <Td>XL</Td>
            <Td>16-18</Td>
            <Td>12-14</Td>
            <Td>46/48</Td>
          </Tr>
          <Tr>
            <Th>5</Th>
            <Td>2XL</Td>
            <Td>18-20</Td>
            <Td>14-16</Td>
            <Td>50/52</Td>
          </Tr>
          <Tr>
            <Th>6</Th>
            <Td>3XL +</Td>
            <Td>22-24</Td>
            <Td>18-20</Td>
            <Td>52/54</Td>
          </Tr>
        </Tbody>
      </Table>
    </TableContainer>
  )
}
